import React  from 'react';
import { useTranslation } from "react-i18next";
import "../translations/i18n";

export const Contact = () => {
 
    const {t} = useTranslation()

        return (
          <div className=''>
            <section id="contact" className="contact">
            <div className="container" data-aos="fade-up">

              <div className="section-header">
                <h2><span className="play-button"></span>{ t("contact.title") }</h2>
                <p>{ t("contact.description") }</p>
              </div>

              <div className="row gx-lg-0 gy-4">

                <div className="col-lg-4">

                  <div className="info-container d-flex flex-column align-items-center justify-content-center">
                    <div className="info-item d-flex">
                      <i className="bi bi-geo-alt flex-shrink-0"></i>
                      <div>
                        <h4>{ t("contact.localisation") }:</h4>
                        <p>Burundi, Bujumbura-Mairie, Zone Rohero,<br /> Avenue de la Revolution No 20 A</p>
                      </div>
                    </div>

                    <div className="info-item d-flex">
                      <i className="bi bi-envelope flex-shrink-0"></i>
                      <div>
                        <h4>Email:</h4>
                        <p>info@b-eyegroup.net</p>
                      </div>
                    </div>

                    <div className="info-item d-flex">
                      <i className="bi bi-phone flex-shrink-0"></i>
                      <div>
                        <h4>Tel:</h4>
                        <p>
                          <a target="_blank" rel="noreferrer" className='text-white' href="https://wa.me/00257625039560"><span>+257 62 503 956</span></a>,
                          <a target="_blank" rel="noreferrer" className='text-white' href="tel:+25767021017"><span>+257 67 021 017</span></a>,
                        </p>
                      </div>
                    </div>

                    <div className="info-item d-flex">
                      <i className="bi bi-clock flex-shrink-0"></i>
                      <div>
                        <h4>{ t("contact.heure") }:</h4>
                        <p>{ t("contact.lundisamedi") }</p>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="col-lg-8">
                  <form action="/" method="get" role="form" className="php-email-form">
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <input type="text" name="name" className="form-control" id="name" placeholder="Votre nom" required />
                      </div>
                      <div className="col-md-6 form-group mt-3 mt-md-0">
                        <input type="email" className="form-control" name="email" id="email" placeholder="Votre Email" required />
                      </div>
                    </div>
                    <div className="form-group mt-3">
                      <input type="text" className="form-control" name="subject" id="subject" placeholder="Sujet" required />
                    </div>
                    <div className="form-group mt-3">
                      <textarea className="form-control" name="message" rows="7" placeholder="Message" required></textarea>
                    </div>
                    <div className="my-3">
                      <div className="loading">Loading</div>
                      <div className="error-message"></div>
                      <div className="sent-message">Your message has been sent. Thank you!</div>
                    </div>
                    <div className="text-center"><button type="submit">{ t("contact.envoyermessage") }</button></div>
                  </form>
                </div>

              </div>

            </div>
          </section>
          </div>
        );
    }
